var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fragment",
    [
      _vm._l(_vm.menuTree, function (list) {
        return [
          list.nodeType == 1 && list.childs.length > 0
            ? _c(
                "el-submenu",
                { key: list.menuId, attrs: { index: list.menuId.toString() } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", { class: list.vchIcon }),
                    _c(
                      "span",
                      {
                        attrs: { slot: "title", title: _vm.$t(list.menuName) },
                        slot: "title",
                      },
                      [_vm._v(_vm._s(_vm.$t(list.menuName)))]
                    ),
                  ]),
                  _c("LeftNavOfWms", { attrs: { menuTree: list.childs } }),
                ],
                2
              )
            : _c(
                "el-menu-item-group",
                { key: list.menuId },
                [
                  _c(
                    "el-menu-item",
                    { key: list.menuId, attrs: { index: list.menuLink } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "light",
                            content: _vm.$t(list.menuName),
                            placement: "top",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t(list.menuName)))])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }